import { createStandardAction } from 'typesafe-actions'

/**
 * Action for answering questions – takes the value of the question and it's index
 */
export const answerQuestion = createStandardAction('answerQuestion')<
  number,
  string
>()
